import React from "react";
import styles from "./breadcrumb.module.scss";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useHistory } from "react-router";

const Breadcrumb = props =>{
    const history=useHistory();
    
    return (
    <div className={styles.breadcrumb}>
        <ul>
            {props.items.map((item, index) => (
                <li key={item.href+index}>
                    {(item.href ? 
                    (<><a onClick={()=>history.push(item.href)}>{item.label}</a> {index+1!=props.items.length&&<ArrowForwardIosIcon className={styles.arrow}></ArrowForwardIosIcon>}</>) 
                    : (item.label) 
                    )}
                </li>)
            )}
        </ul>
    </div>
)};

export default Breadcrumb;

